var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-radius":"4px","overflow":"hidden"}},[_c('chartTitle',[_vm._v(" MEC Distribution (ng/L) ")]),_c('lineChart',{ref:"linechart",attrs:{"lineChartData":_vm.mec.lineChartData,"height":_vm.height - 10},on:{"loading":function($event){return _vm.$emit('loading')},"loaded":function($event){return _vm.$emit('loaded')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }